import { createApp, h } from 'vue';
import Button from 'primevue/button';

let appendAlert;

export default {
  install(app) {
    appendAlert = (message, type, timeout = 5000, remove = true) => {
      const alertPlaceholder = document.getElementById('liveAlertPlaceholder');
      const wrapper = document.createElement('div');
      wrapper.classList.add('alert', `alert-${type}`, 'alert-dismissible', 'fade', 'show');
      wrapper.setAttribute('role', 'alert');
      // Чтобы кнопка могла позиционироваться относительно контейнера
      wrapper.style.position = 'relative';

      // Текст сообщения
      const messageDiv = document.createElement('div');
      messageDiv.innerText = message;

      // Контейнер для кнопки, позиционированный в правом верхнем углу
      const closeButtonContainer = document.createElement('div');
      closeButtonContainer.style.position = 'absolute';
      closeButtonContainer.style.top = '0';
      closeButtonContainer.style.right = '0';

      // Монтируем Vue-компонент Button
      const closeApp = createApp({
        render() {
          return h(Button, {
            icon: 'pi pi-times',
            variant: 'text',
            rounded: true,
            'aria-label': 'Close',
            style: {
              color: '#333'
            },
            onClick: () => {
              wrapper.remove();
            }
          });
        }
      });
      closeApp.mount(closeButtonContainer);

      // Собираем алерт: сообщение и кнопка закрытия
      wrapper.appendChild(messageDiv);
      wrapper.appendChild(closeButtonContainer);
      alertPlaceholder.appendChild(wrapper);

      // Автоматическое удаление алерта через timeout
      if (remove) {
        setTimeout(() => {
          wrapper.remove();
        }, timeout);
      }
    };

    app.config.globalProperties.$alert = { appendAlert };
  }
};

export { appendAlert };